<div class="reports-container">
  <!-- <div class="dashboard__button-container">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'chart-line']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToMovementReport()">
      {{ 'webPos.MovementReport' | translate }}
    </app-card-button>
  </div>
  <div class="dashboard__button-container">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'file-invoice']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToClosingReport()">
      {{ 'webPos.ValuablesReport' | translate }}
    </app-card-button>
  </div> -->
  <div class="dashboard__button-container">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'receipt']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToTransactionsListReport()">
      {{ 'webPos.TransactionsListReport' | translate }}
    </app-card-button>
  </div>

  <div class="dashboard__button-container">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'cash-register']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToPosStateReport()">
      {{ 'webPos.PosStateReport' | translate }}
    </app-card-button>
  </div>

  <div class="dashboard__button-container">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'book']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToPosBookReport()">
      {{ 'webPos.PosBookReport' | translate }}
    </app-card-button>
  </div>
</div>
